import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import combineStyles from '../../../../utils/combineStyles';
import TypographyStyles from '../../../../styles/typography';
import LayoutStyles from '../../../../styles/layout';
import SpacingStyles from '../../../../styles/helpers/spacing';
import ButtonStyles from '../../../../styles/button';
import UnitStyles from './__styles__/Unit.styles';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import Unit from './Unit';
import { FieldArray } from 'formik';
import Button from '@material-ui/core/Button';
import classnames from 'classnames';
import _isEqual from 'lodash/isEqual';
import FormItemContainer from './../../../Global/Containers/FormItemContainer';
import { AppContext } from '../../../../AppProvider';
import { theme } from '../../../Theme';

const styles = theme => ({
  addUnitButton: {
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3
  }
  
});
export class ShipmentContents extends Component {
  static propTypes = {
    //  values: PropTypes.object.isRequired,
    handlingUnits: PropTypes.array.isRequired,
    handleChange: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    showProduct: PropTypes.bool,
    handleValidateField: PropTypes.func.isRequired,
    isQuickRate: PropTypes.bool,
    contacts: PropTypes.array
  };
  _createUnit = () => {
    const {
      defaultWeightUnit: weightUnit,
      defaultCurrency: currency,
      defaultDimensionUnit: dimensionUnit
    } = this.context.globalProps.orgInfo.config;
    return {
      shipmentItems: [],
      weightUnit,
      dimensionUnit,
      weightPerUnit: 0,
      unitCount: 1,
      currency,
      doNotStack: false
    };
  };
  shouldComponentUpdate(nextProps) {
    if (!_isEqual(nextProps.handlingUnits, this.props.handlingUnits)) {
      return true;
    }
    return false;
  }
  render() {
    const {
      classes,
      t,
      handlingUnits,
      handleChange,
      handleValidateField,
      setFieldValue,
      showProduct = true,
      isQuickRate = false,
      contacts
    } = this.props;

    return (
      <FormItemContainer title={t('Shipment Contents')}>
        <FieldArray
          name="handlingUnits"
          validateOnChange={false}
          render={arrayHelpers => (
            <Fragment>
              <div className={classes.containerPadding}>
                {handlingUnits.map((unit, index) => {
                  return (
                    <Unit
                      unit={unit}
                      key={unit.id || index}
                      unitNumber={index}
                      handleChange={handleChange}
                      handleValidateField={handleValidateField}
                      onRemove={() => arrayHelpers.remove(index)}
                      setFieldValue={setFieldValue}
                      showProduct={showProduct}
                      isQuickRate={isQuickRate}
                      contacts={contacts}
                    />
                  );
                })}
              </div>
              <div  style={{marginTop: theme.spacing.unit * 2}} className={classes.addUnitButton}>
                <Button
                  variant="outlined"
                  color="primary"
                  className={classnames(
                    classes.outlinedButton,
                    classes.noMarginBottom,
                    classes.marginTop2
                  )}
                  classes={{ label: classes.buttonLabel }}
                  onClick={() => {
                    arrayHelpers.push(this._createUnit());
                  }}
                >
                  {t('Add a Unit')}
                </Button>
              </div>
            </Fragment>
          )}
        />
      </FormItemContainer>
    );
  }
}

ShipmentContents.contextType = AppContext;
const translatedShipmentContents = withNamespaces()(ShipmentContents);
export default withStyles(
  combineStyles(
    TypographyStyles,
    LayoutStyles,
    ButtonStyles,
    UnitStyles,
    SpacingStyles,
    styles,
  )
)(translatedShipmentContents);
